// import QrJobService from "../service/QrJobService";

// export const QrJobAction = (postData) => async (dispatch) => {
//   dispatch({ type: "FETCH_ASSIGN_JOB_QR_REQUEST" });

//   try {
//     console.log("Sending POST to:", "JobAttendanceQR", postData);
//     console.log("QrJobService baseURL:", QrJobService.defaults.baseURL);


//     const response = await QrJobService.post("JobAttendanceQR", postData);

//     console.log("QR API RESPONSE:", response.data);

//     dispatch({
//       type: "FETCH_ASSIGN_JOB_QR_SUCCESS",
//       payload: response.data,
//     });
//   } catch (error) {
//     console.error("QR API ERROR:", error.response || error.message);
//     dispatch({
//       type: "FETCH_ASSIGN_JOB_QR_FAILURE",
//       error: error.message,
//     });
//   }
// };


import QrJobService from "../service/QrJobService";

export const QrJobAction = (postData) => async (dispatch) => {
  dispatch({ type: "FETCH_ASSIGN_JOB_QR_REQUEST" });

  try {
    console.log("Sending POST to:", "JobAttendanceQR", postData);
    console.log("QrJobService baseURL:", QrJobService.defaults.baseURL);


    const response = await QrJobService.post("JobAttendanceQR", postData);

    console.log("QR API RESPONSE:", response.data);

    dispatch({
      type: "FETCH_ASSIGN_JOB_QR_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    console.error("QR API ERROR:", error.response || error.message);
    dispatch({
      type: "FETCH_ASSIGN_JOB_QR_FAILURE",
      error: error.message,
    });
  }
};

